<svg [attr.width]="width" height="5">
  <rect
    *ngFor="let percent of progressData; index as i"
    [attr.y]="i * 3"
    [attr.width]="(width / 100) * percent"
    fill="#2F80EDFF"
    height="2"
  ></rect>
</svg>
